import { CatButton } from '@blocks-react/components/Button';
import { CatIconArrowForward } from '@blocks-react/components/Icons/ArrowForward';
import { CatIconChevronRight } from '@blocks-react/components/Icons/ChevronRight';
import { ServiceInsightViewDetailsProps } from '../../types';
import styles from '../../customer-account.module.scss';

export const ServiceInsightViewDetails = ({
  serviceInsightTranslation,
  handleRedirectUrlToAlp,
  serviceInsights,
  isDeskTop
}: ServiceInsightViewDetailsProps) => {
  const handleClick = () => {
    if (serviceInsights && handleRedirectUrlToAlp)
      handleRedirectUrlToAlp(serviceInsights.id, serviceInsights.equipmentInfo);
  };
  return (
    <>
      {isDeskTop ? (
        <CatButton
          variant="ghost"
          size="sm"
          aria-label={serviceInsightTranslation?.buttonText}
          onClick={handleClick}
        >
          {serviceInsightTranslation?.buttonText}
          <CatIconArrowForward slot="after" />
        </CatButton>
      ) : (
        <div className={styles['service_card_Icon']}>
          <CatIconChevronRight />
        </div>
      )}
    </>
  );
};
